import styled from 'styled-components';

export const Box = styled.div<{
  is_horizontal?: boolean;
  isShifted?: boolean;
  background?: string;
}>`
  display: flex;
  align-items: center;
  height: ${(props) => (props.is_horizontal ? '120px' : '150px')};
  width: ${(props) => (props.is_horizontal ? '150px' : '120px')};
  background-color: #e0dedf;
  position: relative;
  background-image: ${(props) => props.background};
  background-size: cover;
  background-position: center;
  border: 1px solid darkgrey;
  margin: 0 12px;
  margin-top: ${(props) => (props.isShifted ? '24px' : '0')};
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
`;

export const BoxText = styled.div`
  position: absolute;
  bottom: -24px;
  left: 50%;
  transform: translateX(-50%);
  color: #555555;
  font-size: 14px;
`;
